<template>
  <div class="access-boundary">
    <slot v-if="isAllowed || isAdmin" />

    <div v-else-if="isPending" />

    <!-- Требуется жесткое сравнение: isAllowed === false -->
    <DefaultLayout v-else-if="isInited && isAllowed === false">
      <LackAccess :is-leader="isLeader" />
    </DefaultLayout>
  </div>
</template>

<script setup lang="ts">
import { computed, inject, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { OrgsApiService } from '~packages/epk-front-shared/api-client';
import { LackAccess } from '~packages/epk-front-shared/ui';

import { DefaultLayout } from '@/app/layouts';
import { useIam } from '@/shared/composables';
import { checkNotificationEpgu } from '@/helpers/checkNotificationEpgu';
import { useLoading } from '@/shared/lib';
import {
  useNotificationStore,
  useOrgStore,
  useRightStore,
} from '@/shared/model';
import { useSystemAnnouncement } from '@/widgets/system-announcement';

const keycloakDao = inject('keycloak-dao') as any;
const { setIsLoading } = useLoading();
const { notifyError } = useNotificationStore();
const token = inject('token') as any;

const as = new OrgsApiService();

const checkNotificationEpguInit = checkNotificationEpgu();
const store = useRightStore();
const orgStore = useOrgStore();
const { isWriteAllowed, init: iamInit } = useIam();
const { tryShow: tryShowAnnouncement } = useSystemAnnouncement();
const route = useRoute();

const isInited = ref(false);
const isPending = ref(false);

const isAdmin = computed(() => {
  if (orgStore.userInfo.approved_roles.find(i => i === 'admin')) return true;
  return false;
});

const isAllowed = computed(() => {
  if (!isPending.value && isInited.value && store.isInited) {
    return store.hasRightWrite || store.checkCanRead(route);
  } else return null;
});

const isLeader = computed(() => orgStore.userInfo.user.user_is_head);

/*  */
const initEnd = () => {
  isPending.value = false;
  setIsLoading(false);
};

const initStart = () => {
  setIsLoading(true);
  isPending.value = true;
};

const roleCheckApply = async () => {
  initStart();

  const r = await as.isIm();
  if (!r.status) {
    notifyError(
      'Не удалось синхронизировать информацию о ролях. Пожалуйста, перезайдите в систему.'
    );
    initEnd();
    return;
  }

  if (r.response.need_update) {
    // await keycloakDao.updateToken(-1);
    await keycloakDao.keycloak.logout();
  }

  iamInit();
  initEnd();
};

const init = async () => {
  isInited.value = false;

  if (!token) {
    notifyError('Отсутствует информация об авторизованном пользователе.');
    return;
  }

  const userNamePreferred = token.preferred_username;
  if (userNamePreferred?.startsWith('esia.')) {
    tryShowAnnouncement();
    isInited.value = true;
    return;
  }

  await roleCheckApply();

  if (isWriteAllowed.value) checkNotificationEpguInit.init();

  tryShowAnnouncement();
  isInited.value = true;
};

onMounted(init);
</script>

<style lang="scss" scoped>
@import './access-boundary';
</style>
